import { useFormState } from 'react-hook-form';
import { FormField } from 'ui/formField';
import { InputField } from 'lib/iterable-hook-form';
import { findErrorMessage } from './ConnectedInputField.utils';

export type ConnectedInputFieldProps = {
  name: string;
  labelText?: string;
  formFieldProps?: {
    [key: string]: any;
  };
  placeholder?: string;
};

export const ConnectedInputField = ({
  labelText,
  name,
  formFieldProps,
  ...props
}: ConnectedInputFieldProps) => {
  const { errors } = useFormState();
  const inputId = `${name}-input`;

  const errorText = findErrorMessage(errors, name);

  return (
    <FormField
      inputId={inputId}
      labelText={labelText}
      errorText={errorText}
      hasError={Boolean(errorText)}
      {...formFieldProps}
    >
      <InputField id={inputId} name={name} {...props} />
    </FormField>
  );
};
